import React, { useEffect, useState, useRef } from "react";
import KeyboardReturnRoundedIcon from "@mui/icons-material/KeyboardReturnRounded";

import InputField from "../../atoms/InputField";
import OnDeviceIndicator from "../../molecules/OnDeviceIndicatorMolecule";
import DropdownMenu from "../../molecules/DropDownMolecule";
import "../../commonComponent/colorChangingBorder.css";
import { enterPressed } from "../../../atoms/misc.atom";
import { useRecoilState, useRecoilValue } from "recoil";
import { noteTitle } from "../../../atoms/note.atom";

const TITLE_INPUT_BASE_CLASS =
  "relative flex h-[38.76px] w-full xl:flex-1 xl:min-w-0 title-input-netpad-hairline bg-surface text-text outline-none rounded-t-[8px] rounded-b-[2px] justify-center items-center transition-shadow";
const TITLE_INPUT_IDLE_CLASS = "title-input-balanced-shadow";
const TITLE_INPUT_LOADING_CLASS = "color-changing-shadow";
const FETCH_HINT_CHIP_CLASS =
  "mr-1.5 hidden shrink-0 items-center gap-1 rounded border border-border bg-surface-muted px-1.5 py-0.5 font-montserrat text-xs text-text md:inline-flex";

const getTitleInputContainerClass = (isLoading) =>
  [
    TITLE_INPUT_BASE_CLASS,
    isLoading ? TITLE_INPUT_LOADING_CLASS : TITLE_INPUT_IDLE_CLASS,
  ].join(" ");

const FetchTitleHint = () => (
  <span
    className={FETCH_HINT_CHIP_CLASS}
    title="Press Enter to fetch the page title"
  >
    <KeyboardReturnRoundedIcon sx={{ fontSize: 14 }} />
    <span className="hidden 2xl:inline">Press Enter To Fetch Title</span>
    <span className="2xl:hidden">Enter</span>
  </span>
);

const TitleInputComponent = ({
  placeholder,
  handleKeyboardEvents,
  onChange,
  value,
  dropdownObject,
  saveMode,
  handleDropDownChange,
  loading = false,
}) => {
  const [showPressEnter, setShowPressEnter] = useState(false);
  const lastKeyUpRef = useRef(Date.now());
  const isEnterPressed = useRecoilValue(enterPressed);
  const [currentNoteTitle, setCurrentNoteTitle] = useRecoilState(noteTitle);
  const timerRef = useRef(null);

  useEffect(() => {
    if (isEnterPressed || currentNoteTitle.length <= 1) {
      setShowPressEnter(false);
      clearInterval(timerRef.current);
    } else {
      timerRef.current = setInterval(() => {
        if (Date.now() - lastKeyUpRef.current >= 1000) {
          setShowPressEnter(true);
        }
      }, 1000);
    }

    return () => clearInterval(timerRef.current);
  }, [isEnterPressed, currentNoteTitle.length]);

  const handleKeyboardUpEvents = () => {
    lastKeyUpRef.current = Date.now();
    if (!isEnterPressed && currentNoteTitle.length > 1) {
      setShowPressEnter(false);
    }
  };

  return (
    <div
      className={getTitleInputContainerClass(loading)}
    >
      {saveMode === "offline" && <OnDeviceIndicator />}
      <div className="flex min-w-0 flex-grow items-center">
        <InputField
          value={value}
          onChange={(e) => {
            onChange(e);
            setCurrentNoteTitle(e.target.value);
          }}
          placeholder={placeholder}
          handleKeyboardEvents={handleKeyboardEvents}
          handleKeyboardUpEvents={handleKeyboardUpEvents}
        />
        {saveMode === "online" && showPressEnter && !isEnterPressed && (
          <FetchTitleHint />
        )}
      </div>

      {saveMode === "online" && (
        <DropdownMenu
          dropdownObject={dropdownObject}
          handleDropdownChange={handleDropDownChange}
        />
      )}
    </div>
  );
};

export default TitleInputComponent;
